// @flow

import type { Action } from "redux-action";
import { beginRequest, completeRequest } from "@store/utils";

import type { ApprovableContainer } from "@modules/service/types";
import type { NurseDeclinedReasonsState, NurseDeclinedReason } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);

const finishRequest = completeRequest(["requestsInProgress"]);

export const onUpdateNurseDeclinedReason = (state: NurseDeclinedReasonsState) => () =>
  startRequest(state);
export const onUpdateNurseDeclinedReasonSuccess = (state: NurseDeclinedReasonsState) => () =>
  finishRequest(state);
export const onUpdateNurseDeclinedReasonError = (state: NurseDeclinedReasonsState) => () =>
  finishRequest(state);

export const onAddNurseDeclinedReason = (state: NurseDeclinedReasonsState) => () =>
  startRequest(state);
export const onAddNurseDeclinedReasonSuccess = (state: NurseDeclinedReasonsState) => () =>
  finishRequest(state);
export const onAddNurseDeclinedReasonError = (state: NurseDeclinedReasonsState) => () =>
  finishRequest(state);
// Get  List

export const onGetNurseDeclinedReasonsList = (state: NurseDeclinedReasonsState) => () =>
  startRequest(state);

export const onGetNurseDeclinedReasonsListSuccess = (state: NurseDeclinedReasonsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  list: payload,
});

export const onGetNurseDeclinedReasonsListError = (state: NurseDeclinedReasonsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Get  Record

export const onGet = (state: NurseDeclinedReasonsState) => () => startRequest(state);

export const onGetSuccess = (state: NurseDeclinedReasonsState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  current: payload,
});

export const onGetError = (state: NurseDeclinedReasonsState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Get  Schema

export const onGetSchema = (state: NurseDeclinedReasonsState) => () => startRequest(state);

export const onGetSchemaSuccess = (state: NurseDeclinedReasonsState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  schema: payload,
});

export const onGetSchemaError = (state: NurseDeclinedReasonsState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Create

export const onNew = (state: NurseDeclinedReasonsState) => (action: Action<void>) => ({
  ...state,
  draft: {},
});

export const onStartDraftSuccess = (state: NurseDeclinedReasonsState) => (
  action: Action<ApprovableContainer<NurseDeclinedReason>>,
) => ({
  ...state,
  draft: (action.payload && action.payload.active) || {},
});

export const setDraft = (state: NurseDeclinedReasonsState) => ({ payload }: Object) => ({
  ...state,
  draft: payload,
});

// Config

export const onSetEnabled = (state: NurseDeclinedReasonsState) => ({ payload }: Object) => ({
  ...state,
  configuration: {
    ...state.configuration,
    enabled: payload,
  },
});

export const onSetStatus = (state: NurseDeclinedReasonsState) => ({ payload }: Object) => ({
  ...state,
  configuration: {
    ...state.configuration,
    status: payload,
  },
});

// Modals

export const onSetShowAddModal = (state: NurseDeclinedReasonsState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showAddModal: payload,
  },
});

export const onSetShowEditModal = (state: NurseDeclinedReasonsState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showEditModal: payload,
  },
});

export const onSetShowDiscardModal = (state: NurseDeclinedReasonsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showDiscardModal: payload,
  },
});

export const onSetShowSubmitModal = (state: NurseDeclinedReasonsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showSubmitModal: payload,
  },
});

export const onSetShowCancelModal = (state: NurseDeclinedReasonsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showCancelModal: payload,
  },
});

export const onSetShowCancelDiscardModal = (state: NurseDeclinedReasonsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showCancelDiscardModal: payload,
  },
});

export const onSetShowDisableModal = (state: NurseDeclinedReasonsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showDisableModal: payload,
  },
});
